import TimeRangePicker from "@wojtekmaj/react-timerange-picker";
import PropTypes from "prop-types";

const FieldTimeRange = ({
                            iconBefore,
                            form: {errors, touched},
                            field: {value, onChange, name}
                        }) => {

    const handleChange = (value) => {
    }
    return (
        <div className={"field FieldTimeRange "}>

            <div className={"bg-white shadow rounded-lg"}>
                <div className="flex">

                    {iconBefore &&
                    <span
                        className="flex items-center justify-center text-gray-400	">
                           {iconBefore}
                        </span>
                    }
                    <TimeRangePicker
                        onChange={handleChange}
                        value={value}
                        name={name}
                        clockIcon={null}
                        clearIcon={null}
                        openClockOnFocus={false}
                        isOpen={false}
                        format={"h:m"}
                        secondAriaLabel={"00"}
                        secondPlaceholder={"00"}
                    />
                </div>
            </div>
            {touched[name] && errors[name] &&
            <p className="text-red-500 text-xs">{errors[name]}</p>
            }
        </div>
    )
}

export default FieldTimeRange;

FieldTimeRange.propTypes = {
    iconBefore: PropTypes.element,
    field: PropTypes.object,
    form: PropTypes.object,
}
